import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetRefunds, GetRefundById, AddRefund, UpdateRefund, DeleteRefund } from '../services/backend';
import { NotifyError } from '../utils/functions';

const REFUNDS_KEY = 'refunds';

export function useGetRefunds(params = {}) {
    return useQuery([REFUNDS_KEY, params], () => GetRefunds(params), {
        staleTime: 0,
        cacheTime: 0,
        select: (data) => data?.data,
        onError: (error) => {
            NotifyError('Failed to fetch refunds', error);
            console.error('Error fetching refunds:', error);
        },
    });
}

export function useGetRefundById(refundId) {
    return useQuery([REFUNDS_KEY, refundId], () => GetRefundById(refundId), {
        enabled: !!refundId,
        select: (data) => data?.data?.refund,
    });
}

export function useAddRefund() {
    const queryClient = useQueryClient();
    return useMutation(AddRefund, {
        onSuccess: () => queryClient.invalidateQueries(REFUNDS_KEY),
    });
}

export function useUpdateRefund() {
    const queryClient = useQueryClient();
    return useMutation(({ refundId, data }) => UpdateRefund(refundId, data), {
        onSuccess: () => queryClient.invalidateQueries(REFUNDS_KEY),
    });
}

export function useDeleteRefund() {
    const queryClient = useQueryClient();
    return useMutation(DeleteRefund, {
        onSuccess: () => queryClient.invalidateQueries(REFUNDS_KEY),
    });
}
